import React, { useEffect, useMemo, useState } from "react";
import { Box, Flex, IconButton, Image, HStack, useColorModeValue } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

import image1 from "../../assets/site-cav_7.png";
import image2 from "../../assets/site-cav_2.png";
import image3 from "../../assets/site-cav_6.jpg";

export default function NewsCarousel() {
  const images = useMemo(() => [image1, image2, image3], []);
  const [idx, setIdx] = useState(0);

  const border = useColorModeValue("rgba(0,0,0,0.08)", "rgba(255,255,255,0.10)");
  const bg = useColorModeValue("white", "rgba(255,255,255,0.03)");
  const dotOff = useColorModeValue("rgba(0,0,0,0.18)", "rgba(255,255,255,0.20)");
  const dotOn = useColorModeValue("#315369", "white");

  const prev = () => setIdx((i) => (i === 0 ? images.length - 1 : i - 1));
  const next = () => setIdx((i) => (i === images.length - 1 ? 0 : i + 1));

  useEffect(() => {
    const t = setInterval(next, 3500);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images.length]);

  return (
    <Box mt="140px">
      <Box maxW="1200px" mx="auto" px={{ base: 4, md: 10 }}>
        <Box
          border="1px solid"
          borderColor={border}
          borderRadius="28px"
          bg={bg}
          overflow="hidden"
          position="relative"
          boxShadow={useColorModeValue("0 14px 40px rgba(0,0,0,0.10)", "none")}
        >
          {/* Ratio box (no crop) */}
          <Box
            w="100%"
            aspectRatio={{ base: 16 / 9, md: 16 / 7 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            bg={useColorModeValue("rgba(49,83,105,0.04)", "rgba(255,255,255,0.04)")}
            px={{ base: 3, md: 6 }}
            py={{ base: 3, md: 5 }}
          >
            <Image
              src={images[idx]}
              alt={`News slide ${idx + 1}`}
              w="100%"
              h="100%"
              objectFit="contain"   // ✅ no cropping
            />
          </Box>

          {/* Arrows */}
          <IconButton
            aria-label="Previous slide"
            icon={<ChevronLeftIcon boxSize={7} />}
            onClick={prev}
            position="absolute"
            left={{ base: 3, md: 4 }}
            top="50%"
            transform="translateY(-50%)"
            borderRadius="16px"
            variant="ghost"
            bg={useColorModeValue("rgba(255,255,255,0.75)", "rgba(0,0,0,0.35)")}
            _hover={{ bg: useColorModeValue("rgba(255,255,255,0.90)", "rgba(0,0,0,0.55)") }}
          />

          <IconButton
            aria-label="Next slide"
            icon={<ChevronRightIcon boxSize={7} />}
            onClick={next}
            position="absolute"
            right={{ base: 3, md: 4 }}
            top="50%"
            transform="translateY(-50%)"
            borderRadius="16px"
            variant="ghost"
            bg={useColorModeValue("rgba(255,255,255,0.75)", "rgba(0,0,0,0.35)")}
            _hover={{ bg: useColorModeValue("rgba(255,255,255,0.90)", "rgba(0,0,0,0.55)") }}
          />

          {/* Dots */}
          <Flex justify="center" py={3}>
            <HStack spacing={2}>
              {images.map((_, i) => (
                <Box
                  key={i}
                  w="10px"
                  h="10px"
                  borderRadius="full"
                  bg={i === idx ? dotOn : dotOff}
                  cursor="pointer"
                  onClick={() => setIdx(i)}
                />
              ))}
            </HStack>
          </Flex>
        </Box>
      </Box>

      <Box mt={6}>
        <hr />
      </Box>
    </Box>
  );
}
